import React, { useCallback } from 'react';
import { rem, SettingsItem, SettingsSection } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import { Keyboard, StyleSheet } from 'react-native';
import Modal from 'utils/packages/Modal';
import Links from 'utils/links';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectIsGBUser, selectIsLoggedIn } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
import ModalContent from './ModalContent';
const strings = {
    headerTitle: 'Frequently asked questions',
    bankNotHere: 'My bank is not here',
    bankNotHereDescription: `If you don't see your bank, we don't currently support it. You can check any ETA or request it on our Community forum.`,
    bankNotHereDescriptionLoggedIn: `If you don't see your bank, we don't currently support it. You can check any ETA or request it on our Community forum. \n\nIn the meantime, you can create an offline account to track your assets.`,
};
const defaultArticles = [
    {
        title: 'What banks do you support in the UK? 🇬🇧',
        link: 'whatBanksDoYouSupportInTheUk',
        gbOnly: true,
    },
    {
        title: "Why can't I add my Savings or ISA's in Emma? 🇬🇧",
        link: 'whyCantIAddSavingsOrIsas',
        gbOnly: true,
    },
    {
        title: 'How safe is Emma App?',
        link: 'howSafeIsEmmaApp',
        linkUs: 'howSafeIsEmmaAppUs',
    },
];
const FAQSection = ({ noMarginTop }) => {
    const navigation = useMainStackNavigation();
    const isGbUser = useAppSelector(selectIsGBUser);
    const isLoggedIn = useAppSelector(selectIsLoggedIn);
    const articles = defaultArticles.filter((article) => !article.gbOnly || isGbUser);
    const onPressVisitCommunity = useCallback(() => {
        Links.openEmmaCommunity();
    }, []);
    const onPressCreateOfflineAccount = useCallback(() => {
        navigation.navigate('PickAccountType', {});
    }, []);
    const onPressBankNotHere = useCallback(() => {
        Keyboard.dismiss();
        Modal.show(isLoggedIn ? (<ModalContent description={strings.bankNotHereDescriptionLoggedIn} primaryButtonTitle={'Create Offline account'} onPrimaryButtonPress={onPressCreateOfflineAccount} secondaryButtonTitle={'Visit community'} onSecondaryButtonPress={onPressVisitCommunity} tertiaryButtonTitle={'Okay, thanks'}/>) : (<ModalContent description={strings.bankNotHereDescription} secondaryButtonTitle={'Visit community'} onSecondaryButtonPress={onPressVisitCommunity} tertiaryButtonTitle={'Okay, thanks'}/>), {
            title: 'Sorry to hear that 😭',
        });
    }, [isLoggedIn, onPressCreateOfflineAccount, onPressVisitCommunity]);
    return (<>
      <SectionHeader horizontalMargins style={[styles.marginBottom, !noMarginTop && styles.marginTop]}>
        {strings.headerTitle}
      </SectionHeader>
      <SettingsSection noMarginTop>
        {!isGbUser && (<SettingsItem title={strings.bankNotHere} onPress={onPressBankNotHere}/>)}
        {articles.map((article) => (<SettingsItem key={article.link} title={article.title} onPress={() => Links.openKnownLink(isGbUser ? article.link : article.linkUs ?? article.link)}/>))}
      </SettingsSection>
    </>);
};
const styles = StyleSheet.create({
    marginTop: {
        marginTop: rem(24),
    },
    marginBottom: {
        marginBottom: rem(16),
    },
});
export default FAQSection;
